/* ATN Digital Showroom - 05 Featured Showrooms (responsive slider) */
(function () {
  if (customElements.get('atn-sr-showrooms')) return;

  var DRAG_THRESHOLD = 6;
  var EDGE_TOLERANCE = 2;

  class AtnSrShowrooms extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-srg-track]');
      if (!this.track) return;

      this.prevBtn = this.querySelector('[data-srg-prev]');
      this.nextBtn = this.querySelector('[data-srg-next]');

      this.isDown = false;
      this.isDragging = false;
      this.suppressClick = false;
      this.startX = 0;
      this.startScroll = 0;
      this.rafId = null;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onDragStart = function (event) { event.preventDefault(); };
      this.onPrev = this.scrollByPage.bind(this, -1);
      this.onNext = this.scrollByPage.bind(this, 1);

      this.track.addEventListener('pointerdown', this.onPointerDown);
      this.track.addEventListener('pointermove', this.onPointerMove);
      this.track.addEventListener('pointerup', this.onPointerUp);
      this.track.addEventListener('pointercancel', this.onPointerUp);
      this.track.addEventListener('dragstart', this.onDragStart);
      this.track.addEventListener('click', this.onClick, true);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);

      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this.track);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      this.update();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('pointerdown', this.onPointerDown);
      this.track.removeEventListener('pointermove', this.onPointerMove);
      this.track.removeEventListener('pointerup', this.onPointerUp);
      this.track.removeEventListener('pointercancel', this.onPointerUp);
      this.track.removeEventListener('dragstart', this.onDragStart);
      this.track.removeEventListener('click', this.onClick, true);
      this.track.removeEventListener('scroll', this.onScroll);
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('resize', this.onResize);
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    /* Grid mode never overflows, so this is false and drag stays off */
    isOverflowing() {
      return this.track.scrollWidth - this.track.clientWidth > EDGE_TOLERANCE;
    }

    /* Mouse drag only - touch uses native scrolling */
    onPointerDown(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (!this.isOverflowing()) return;

      this.isDown = true;
      this.isDragging = false;
      this.suppressClick = false;
      this.startX = event.clientX;
      this.startScroll = this.track.scrollLeft;
    }

    onPointerMove(event) {
      if (!this.isDown) return;
      var delta = event.clientX - this.startX;

      if (!this.isDragging) {
        if (Math.abs(delta) < DRAG_THRESHOLD) return;
        this.isDragging = true;
        this.track.classList.add('is-dragging');
        if (this.track.setPointerCapture) {
          try { this.track.setPointerCapture(event.pointerId); } catch (e) {}
        }
      }

      event.preventDefault();
      this.track.scrollLeft = this.startScroll - delta;
    }

    onPointerUp(event) {
      if (!this.isDown) return;
      this.isDown = false;

      if (this.isDragging) {
        this.suppressClick = true;
        this.track.classList.remove('is-dragging');
        if (this.track.releasePointerCapture) {
          try { this.track.releasePointerCapture(event.pointerId); } catch (e) {}
        }
      }
      this.isDragging = false;
    }

    /* Stop button navigation right after a drag */
    onClick(event) {
      if (!this.suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      this.suppressClick = false;
    }

    onScroll() {
      if (this.rafId) return;
      var self = this;
      this.rafId = requestAnimationFrame(function () {
        self.rafId = null;
        self.update();
      });
    }

    onResize() {
      this.update();
    }

    getStep() {
      var card = this.track.querySelector('.atn-sr-grid__card');
      if (!card) return this.track.clientWidth;
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByPage(direction) {
      var step = this.getStep();
      var perView = Math.max(1, Math.floor(this.track.clientWidth / step));
      this.track.scrollBy({ left: direction * step * perView, behavior: 'smooth' });
    }

    update() {
      var max = this.track.scrollWidth - this.track.clientWidth;
      var overflowing = max > EDGE_TOLERANCE;
      var x = this.track.scrollLeft;
      var atStart = x <= EDGE_TOLERANCE;
      var atEnd = x >= max - EDGE_TOLERANCE;

      this.classList.toggle('is-start', !overflowing || atStart);
      this.classList.toggle('is-end', !overflowing || atEnd);

      /* Prev shows only when back-scroll is possible, next only when forward is */
      if (this.prevBtn) {
        this.prevBtn.classList.toggle('is-hidden', !overflowing || atStart);
        this.prevBtn.setAttribute('tabindex', !overflowing || atStart ? '-1' : '0');
      }
      if (this.nextBtn) {
        this.nextBtn.classList.toggle('is-hidden', !overflowing || atEnd);
        this.nextBtn.setAttribute('tabindex', !overflowing || atEnd ? '-1' : '0');
      }
    }
  }

  customElements.define('atn-sr-showrooms', AtnSrShowrooms);
})();